import { Subscription } from 'rxjs/Subscription';
import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { EffectSources } from './effect_sources';
export class EffectsRunner implements OnDestroy {
private effectsSubscription: Subscription | null = null;
/**
 * @param {?} effectSources
 * @param {?} store
 */
constructor(
private effectSources: EffectSources,
private store: Store<any>
  ) {}
/**
 * @return {?}
 */
start() {
    if (!this.effectsSubscription) {
      this.effectsSubscription = this.effectSources
        .toActions()
        .subscribe(this.store);
    }
  }
/**
 * @return {?}
 */
ngOnDestroy() {
    if (this.effectsSubscription) {
      this.effectsSubscription.unsubscribe();
      this.effectsSubscription = null;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: EffectSources, },
{type: Store, },
];
}

function EffectsRunner_tsickle_Closure_declarations() {
/** @type {?} */
EffectsRunner.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EffectsRunner.ctorParameters;
/** @type {?} */
EffectsRunner.prototype.effectsSubscription;
/** @type {?} */
EffectsRunner.prototype.effectSources;
/** @type {?} */
EffectsRunner.prototype.store;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/effects/src/effects_runner.ts